<style src="./SearchTrack.scss" lang="scss"></style>

<template lang="pug">
  article.search-track
    h4.search-track__name
      router-link.search-track__link(
        :title='track.name'
        :to='`/tracks/${track.id}`'
      ) {{ track.name }}
    .search-track__artists
      router-link.search-track__artist(
        v-if='artist'
        v-for='artist in track.artists'
        :key='artist.id'
        :to='`/artists/${artist.id}`'
      ) {{ artist.name }}
    .search-track__duration {{ track.duration | duration }}
    button.search-track__add-button(
      @click='addToPlaylist'
      type='button'
    )
      Icon( name='add' )
      span {{ $l10n("ADD") }}
</template>
<script>
import Icon from "@/components/Icon/Icon";

import { mapActions } from "vuex";

export default {
  name: "SearchTrack",
  props: ["track", "playlistId"],
  components: {
    Icon
  },
  methods: {
    ...mapActions({
      addTracksToPlaylist: "playlists/addTracks"
    }),
    addToPlaylist() {
      this.addTracksToPlaylist({
        tracksIds: [this.track.id],
        playlistId: this.playlistId
      });
    }
  }
};
</script>
